$(document).ready(function(){ 
  var zoomImages = $('.product_zooms'); 
  zoomImages.each(function() 
                  { 
    $(this).imageZoom(); 
                  }); 
var iscountdown = $('body').attr('is-countdown');
  if(typeof iscountdown !== 'undefined' && iscountdown !== false ){
  
  

 var countdown = $('body').attr("data-countdown");
 // Set the date we're counting down to
var countDownDate = new Date(countdown).getTime();

// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  $(".countdown-wrapper").text(  days + "d " + hours + "h "
  + minutes + "m " + seconds + "s ");
  
  var addToCart = $('.product-detail__form__action button');
  if (addToCart.attr('disabled') == 'disabled' && addToCart.text() == 'add to cart'){
    
  } else{
  addToCart.attr('disabled','disabled');
  addToCart.text($('body').attr('data-add-to-cart-text'));
  }
  // If the count down is finished, write some text 
  if (distance < 0) {
    clearInterval(x);
    $(".thisiscountdown").attr('style','display:none;');
    addToCart.removeAttr('disabled');
    addToCart.text('add to cart');
  }
}, 1000);

  }
});
